import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import telHref from "../../helpers/adressHelpers/telHref.js";

/**
 * Belknop bij een adres in de mobiele weergave.
 *
 * Rendert niets zolang er geen nummer bekend is. Dat is bewust: een dode
 * belknop laat een fixer voor de deur denken dat er gebeld kan worden, en het
 * verschil tussen 'geen nummer' en 'bellen lukt niet' is buiten niet te zien.
 *
 * @param {object} props
 * @param {string} props.phone - Het telefoonnummer zoals het is ingevoerd; leeg wanneer er geen bekend is
 * @param {string} props.label - Waar gebeld wordt, voor de schermlezer — bijv. 'Kerkstraat 12'
 */
const CallLink = ({ phone, label }) => {
  const href = telHref(phone);

  if (!href) return null;

  return (
    <a className="mobile-call-link" href={href} aria-label={`Bel ${label}`}>
      <PhoneOutlinedIcon />
      <span>{phone}</span>
    </a>
  );
};

export default CallLink;
